"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const colorScheme_1 = require("colorScheme");
const tabby_terminal_1 = require("tabby-terminal");
const tabby_core_1 = require("tabby-core");
let AltairTheme = class AltairTheme extends tabby_core_1.Theme {
    constructor() {
        super(...arguments);
        this.name = "Altair";
        this.css = require("./theme.scss");
        this.terminalBackground = "#22242d";
    }
};
AltairTheme = __decorate([
    (0, core_1.Injectable)()
], AltairTheme);
let AltairThemeModule = class AltairThemeModule {
};
AltairThemeModule = __decorate([
    (0, core_1.NgModule)({
        providers: [
            { provide: tabby_core_1.Theme, useClass: AltairTheme, multi: true },
            {
                provide: tabby_terminal_1.TerminalColorSchemeProvider,
                useClass: colorScheme_1.AltairColorScheme,
                multi: true,
            },
        ],
    })
], AltairThemeModule);
exports.default = AltairThemeModule;
